module.exports = __webpack_public_path__ + "static/media/acai_berry_maxi_plan.94b8c78b.jpg";